import React, { useEffect, useMemo, useRef } from "react";
import { sanitizeHtml } from "@/components/RichTextEditor";
import { cn } from "@/lib/utils";

const SafeHtml = ({ html, className, onLinkClick, testId }) => {
  const ref = useRef(null);
  const cleanHtml = useMemo(() => sanitizeHtml(html), [html]);

  useEffect(() => {
    ref.current?.querySelectorAll("a").forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });
  }, [cleanHtml]);

  const handleClick = (event) => {
    if (event.target.closest("a")) {
      onLinkClick?.();
    }
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      onClick={handleClick}
      className={cn("article-content", className)}
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
    />
  );
};

export default SafeHtml;
